import { render, staticRenderFns } from "./gj-all-category-select.vue?vue&type=template&id=6dafd05e&scoped=true&"
import script from "./gj-all-category-select.vue?vue&type=script&lang=js&"
export * from "./gj-all-category-select.vue?vue&type=script&lang=js&"
import style0 from "./gj-all-category-select.vue?vue&type=style&index=0&id=6dafd05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafd05e",
  null
  
)

export default component.exports